<style lang="scss" scoped>
/* 变更日志弹窗 */
.log-detail {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.asset-pagination {
    margin-top: 16px;
    overflow-x: auto;
}

/* 筛选区：与 VehicleQuery 顶部工具栏一致（栅格自适应，label 两端对齐，控件占满） */
.filter-cell {
    display: flex;
    align-items: center;
    min-width: 0;
    margin-bottom: 10px;

    .el-input,
    .el-select,
    .el-date-editor {
        flex: 1;
        min-width: 0;
    }
}

/* label 两端对齐，冒号统一 */
.filter-label {
    flex: none;
    display: inline-flex;
    color: #606266;
    white-space: nowrap;
}

.filter-label-text {
    width: 72px;
    text-align: justify;
    text-align-last: justify;
}

.filter-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    white-space: nowrap;
}
</style>

<style lang="scss">
/* append-to-body 弹窗脱离组件作用域：宽度由 c-el-dialog(96%) 自适应，修饰类单独封顶 */
.asset-dialog--logs {
    margin-top: 5vh !important;
    max-width: 96%;
}
</style>

<template>
    <el-dialog :title="`变更日志 - ${currentTab.label}`" :visible.sync="visible" append-to-body custom-class="c-el-dialog asset-dialog asset-dialog--logs">
        <!-- 类型页签：每个类型独立保存查询条件与结果，切换不丢失（默认车辆同步日志） -->
        <el-tabs v-model="activeTab" class="mrgb5" @tab-click="tabClick">
            <el-tab-pane v-for="tab in tabs" :key="tab.key" :label="tab.label" :name="tab.key" />
        </el-tabs>
        <!-- 弹窗内筛选区：字段名随当前页签类型变化（业务键/辅助键即实际业务字段） -->
        <el-card class="mrgb10">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="filter-cell">
                        <span class="filter-label"><span class="filter-label-text">{{ currentTab.bizLabel }}</span>：</span>
                        <el-input v-model.trim="currentState.query.businessKey" size="medium" clearable :placeholder="`请输入${currentTab.bizLabel}`" @clear="search" />
                    </div>
                </el-col>
                <el-col v-if="currentTab.aux1Label" :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="filter-cell">
                        <span class="filter-label"><span class="filter-label-text">{{ currentTab.aux1Label }}</span>：</span>
                        <el-input v-model.trim="currentState.query.auxiliaryKey" size="medium" clearable :placeholder="`请输入${currentTab.aux1Label}`" @clear="search" />
                    </div>
                </el-col>
                <el-col v-if="currentTab.aux2Label" :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="filter-cell">
                        <span class="filter-label"><span class="filter-label-text">{{ currentTab.aux2Label }}</span>：</span>
                        <el-input v-model.trim="currentState.query.auxiliaryKey2" size="medium" clearable :placeholder="`请输入${currentTab.aux2Label}`" @clear="search" />
                    </div>
                </el-col>
                <!-- 时间范围：datetimerange + 快捷选项，与其他列表页一致 -->
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="filter-cell">
                        <span class="filter-label"><span class="filter-label-text">时间范围</span>：</span>
                        <el-date-picker v-model="currentState.selectedTime" type="datetimerange" size="medium" :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" align="right" @change="search" />
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="filter-cell">
                        <span class="filter-label"><span class="filter-label-text">动作</span>：</span>
                        <el-select v-model="currentState.query.action" size="medium" clearable placeholder="请选择动作" @change="enumChanged('action', $event)">
                            <el-option v-for="item in arrVehicleDataChangeAction" :key="item.value" :label="item.desc" :value="item.value" />
                        </el-select>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="filter-cell">
                        <span class="filter-label"><span class="filter-label-text">来源</span>：</span>
                        <el-select v-model="currentState.query.source" size="medium" clearable placeholder="请选择来源" @change="enumChanged('source', $event)">
                            <el-option v-for="item in arrVehicleDataChangeSource" :key="item.value" :label="item.desc" :value="item.value" />
                        </el-select>
                    </div>
                </el-col>
                <el-col v-if="currentTab.batch" :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="filter-cell">
                        <span class="filter-label"><span class="filter-label-text">批次</span>：</span>
                        <el-input v-model.trim="currentState.query.batchId" size="medium" clearable placeholder="请输入批次" @clear="search" />
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <div class="filter-cell">
                        <span class="filter-label"><span class="filter-label-text">关键字</span>：</span>
                        <el-input v-model.trim="currentState.query.keywords" size="medium" clearable placeholder="请输入关键字" @clear="search" />
                    </div>
                </el-col>
                <!-- 操作按钮：独占一行靠右 -->
                <el-col :span="24">
                    <div class="fr filter-actions">
                        <el-button type="primary" size="medium" @click="search()"><i class="fa fa-search"></i> 查询</el-button>
                        <el-button size="medium" @click="reset"><i class="fa fa-undo"></i> 重置</el-button>
                    </div>
                    <div class="clearb"></div>
                </el-col>
            </el-row>
        </el-card>
        <!-- :key=当前页签：element-ui 2.13 的 el-table-column 对 v-if 切列支持不佳，按页签重建表格避免列注册错乱（数据在各页签状态里，不丢失） -->
        <el-table :key="activeTab" v-loading="currentState.loading" :data="currentState.rows" style="width: 100%" border size="medium" max-height="420">
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <el-table v-if="Array.isArray(details(scope.row.detail))" :data="details(scope.row.detail)" size="mini" border>
                        <el-table-column prop="field" label="字段" width="160" />
                        <el-table-column label="修改前"><template slot-scope="diff">{{ display(diff.row.old) }}</template></el-table-column>
                        <el-table-column label="修改后"><template slot-scope="diff">{{ display(diff.row.new) }}</template></el-table-column>
                    </el-table>
                    <pre v-else class="log-detail">{{ display(details(scope.row.detail)) }}</pre>
                </template>
            </el-table-column>
            <el-table-column label="时间" width="165"><template slot-scope="scope">{{ dateTime(scope.row.creationTime) }}</template></el-table-column>
            <el-table-column v-if="currentTab.operator" prop="operatorName" label="操作人" width="100" />
            <el-table-column label="动作" width="100"><template slot-scope="scope">{{ actionName(scope.row.action) }}</template></el-table-column>
            <el-table-column label="来源" width="70"><template slot-scope="scope">{{ sourceName(scope.row.source) }}</template></el-table-column>
            <el-table-column :prop="'businessKey'" :label="currentTab.bizLabel" min-width="160" />
            <el-table-column v-if="currentTab.aux1Label" prop="auxKey1" :label="currentTab.aux1Label" min-width="140" />
            <el-table-column v-if="currentTab.aux2Label" prop="auxKey2" :label="currentTab.aux2Label" min-width="110" />
            <el-table-column v-if="currentTab.batch" prop="batchId" label="批次" min-width="160" />
            <!-- 行级跨类型追查：带键值切到对应类型页签立即查询，本页签状态不受影响；单个直接文字按钮，多个收纳进"追查"下拉 -->
            <el-table-column v-if="currentTab.jumps.length" label="追查" width="100" fixed="right">
                <template slot-scope="scope">
                    <el-button v-if="availableJumps(scope.row).length === 1" type="text" size="mini" @click="jumpTo(scope.row, availableJumps(scope.row)[0])">{{ availableJumps(scope.row)[0].label }}</el-button>
                    <el-dropdown v-else-if="availableJumps(scope.row).length > 1" trigger="click" @command="jump => jumpTo(scope.row, jump)">
                        <el-button type="primary" plain size="mini">追查<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="jump in availableJumps(scope.row)" :key="jump.label" :command="jump">{{ jump.label }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="asset-pagination" background :current-page.sync="currentState.query.page" :page-size="currentState.query.size" :total="currentState.total" layout="total, prev, pager, next" @current-change="load"></el-pagination>
    </el-dialog>
</template>

<script>
    // 中控 / 车架 / 保单 / 车架保险 / 车辆同步的变更日志弹窗：按类型页签拆分查询，页签间状态互不影响
    import moment from 'moment'
    import { vehicleDataApi } from '@/api/vehicleData'
    import enumConfigs from '@/mixins/enumConfigs'

    // 类型页签配置：字段名按该类型日志的实际键位命名；同步日志为系统写入，无操作人与批次；jumps 为行级跨类型追查（key=目标页签要填的筛选字段，from=取行上哪个键）
    const tabConfigs = [
        { key: 'VehicleSync', label: '车辆同步日志', bizLabel: '车辆号', aux1Label: '中控号', aux2Label: '平台', operator: false, batch: false, jumps: [{ label: '查中控', target: 'Control', key: 'businessKey', from: 'auxiliaryKey' }] },
        { key: 'Control', label: '中控日志', bizLabel: '中控号', aux1Label: '车架号', operator: true, batch: true, jumps: [{ label: '查车架', target: 'Chassis', key: 'businessKey', from: 'auxiliaryKey' }, { label: '查车辆同步', target: 'VehicleSync', key: 'auxiliaryKey', from: 'businessKey' }] },
        { key: 'Chassis', label: '车架日志', bizLabel: '车架号', operator: true, batch: true, jumps: [{ label: '查中控', target: 'Control', key: 'auxiliaryKey', from: 'businessKey' }, { label: '查车架保险', target: 'Insurance', key: 'businessKey', from: 'businessKey' }] },
        { key: 'Insurance', label: '车架保险日志', bizLabel: '车架号', aux1Label: '保单号', operator: true, batch: true, jumps: [{ label: '查车架', target: 'Chassis', key: 'businessKey', from: 'businessKey' }, { label: '查保单', target: 'Policy', key: 'businessKey', from: 'auxiliaryKey' }] },
        { key: 'Policy', label: '保单日志', bizLabel: '保单号', operator: true, batch: true, jumps: [{ label: '查车架保险', target: 'Insurance', key: 'auxiliaryKey', from: 'businessKey' }] }
    ]

    // 每个类型页签独立的查询状态：条件 + 结果 + 页码，切换页签不重置
    const newTabState = () => ({ loaded: false, loading: false, rows: [], total: 0, selectedTime: [], query: { page: 1, size: 20, businessKey: '', auxiliaryKey: '', auxiliaryKey2: '', batchId: '', action: null, source: null, keywords: '' } })

    export default {
        mixins: [enumConfigs],
        data() {
            const states = {}
            tabConfigs.forEach(tab => { states[tab.key] = newTabState() })
            return {
                visible: false,
                tabs: tabConfigs,
                activeTab: 'VehicleSync',
                states
            }
        },
        computed: {
            currentTab() { return this.tabs.find(tab => tab.key === this.activeTab) },
            currentState() { return this.states[this.activeTab] },
            // 时间范围快捷选项（与其他列表页一致）
            pickerOptions() {
                // 生成快捷项：起始时间往前推 spaceTime 个 unit，截止到昨天 23:59:59
                const shortcut = (text, spaceTime, unit) => ({
                    text,
                    onClick: picker => picker.$emit('pick', [
                        moment().subtract(spaceTime, unit).format('YYYY-MM-DD 00:00:00'),
                        moment().subtract(1, 'd').format('YYYY-MM-DD 23:59:59')
                    ])
                })
                return {
                    shortcuts: [
                        shortcut('昨天', 1, 'd'),
                        shortcut('近一周', 1, 'w'),
                        shortcut('近一月', 1, 'M'),
                        shortcut('近三月', 3, 'M'),
                        shortcut('近半年', 6, 'M'),
                        shortcut('近一年', 1, 'y')
                    ]
                }
            }
        },
        methods: {
            dateTime(value) { return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : '-' },
            // 按枚举数组把值转成描述文本
            enumDesc(arrs, value) {
                const item = (arrs || []).find(i => i.value === value)
                return item ? item.desc : (value == null || value === '' ? '-' : value)
            },
            actionName(value) { return this.enumDesc(this.arrVehicleDataChangeAction, value) },
            sourceName(value) { return this.enumDesc(this.arrVehicleDataChangeSource, value) },
            // 打开弹窗：带类型上下文则重置该类型页签并预填查询（业务键/关键字/辅助键），否则默认落在车辆同步日志；其它页签状态不受影响
            open(entityType, businessKey = '', keywords = '', auxiliaryKey = '') {
                const tab = entityType == null
                    ? this.tabs[0]
                    : this.tabs.find(item => this[`valVehicleDataChangeEntityType${item.key}`]() === entityType)
                this.states[tab.key] = newTabState()
                this.states[tab.key].query.businessKey = businessKey || ''
                this.states[tab.key].query.keywords = keywords || ''
                this.states[tab.key].query.auxiliaryKey = auxiliaryKey || ''
                this.activeTab = tab.key
                this.visible = true
                this.load()
            },
            // 切换页签：首次进入自动查最新，再次切回显示保留的查询结果
            tabClick() { if (!this.currentState.loaded) this.load() },
            // 枚举下拉清空时转为 null 再查询
            enumChanged(field, value) { this.currentState.query[field] = value === '' || value == null ? null : value; this.search() },
            search() { this.currentState.query.page = 1; this.load() },
            reset() { this.states[this.activeTab] = newTabState(); this.load() },
            async load() {
                const state = this.currentState
                state.loading = true
                try {
                    // 时间范围转为接口的 StartDate / EndDate
                    const [startDate, endDate] = (state.selectedTime || []).map(t => (t ? moment(t).format('YYYY-MM-DD HH:mm:ss') : ''))
                    const params = { ...state.query, entityType: this[`valVehicleDataChangeEntityType${this.activeTab}`](), startDate: startDate || undefined, endDate: endDate || undefined }
                    const result = await vehicleDataApi.logs(params)
                    state.rows = result.items || []
                    state.total = Number(result.totalCount || 0)
                } catch (_) { state.rows = []; state.total = 0 } finally { state.loading = false }
                state.loaded = true
            },
            // 行上可用的追查项：导入汇总是批次统计记录、业务键非具体业务数据，不提供追查；其余按来源键有值过滤
            availableJumps(row) {
                if (row.action === this.valVehicleDataChangeActionImportSummary()) return []
                return this.currentTab.jumps.filter(jump => this.jumpValue(row, jump))
            },
            // 追查按钮可用性：来源键上有值才显示
            jumpValue(row, jump) {
                const value = jump.from === 'businessKey' ? row.businessKey : row.auxKey1
                return !!value
            },
            // 跨类型追查：切到目标页签，清掉键值类筛选后填入追查键立即查询（时间/动作/来源等保留）
            jumpTo(row, jump) {
                const value = jump.from === 'businessKey' ? row.businessKey : row.auxKey1
                if (!value) return
                const state = this.states[jump.target]
                state.query.businessKey = ''
                state.query.auxiliaryKey = ''
                state.query.auxiliaryKey2 = ''
                state.query[jump.key] = value
                state.query.page = 1
                this.activeTab = jump.target
                this.load()
            },
            details(value) { try { return JSON.parse(value) } catch (_) { return value } },
            display(value) { return value == null ? '-' : typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value) }
        }
    }
</script>
